import { connect } from 'react-redux';
import LatestNotifications from './LatestNotifications';
import { createFeedback } from '../../../../redux/actions/feedback_actions';
import { withRouter } from 'react-router-dom';
import { fetchAllUsers, addNewNotification, updateUserNotificationRead, fetchUserNotifications } from '../../../../redux/actions/user_actions';
import { fetchNotifications } from '../../../../redux/actions/notification_actions';

const mSTP = state => ({
  currentUserId: state.session.user.id,
  currentUser: state.session.user.username,
  currentUserRole: state.session.user.role
});

const mDTP = dispatch => ({
  fetchAllUsers: () => dispatch(fetchAllUsers()),
  updateUserNotificationRead: (userId) => dispatch(updateUserNotificationRead(userId)),
  fetchNotifications: (fetchUnread) => dispatch(fetchNotifications(fetchUnread)),
  createFeedback: (feedback) => dispatch(createFeedback(feedback)),
  addNewNotification: (payload) => dispatch(addNewNotification(payload))
});

export default withRouter(connect(mSTP, mDTP)(LatestNotifications));